import { mapState } from 'vuex';
import WidgetTypeSelect from './widgetTypeSelect.vue';
import WidgetSizeSelect from './sizeSelect.vue';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import TemplateTextField from './templateTextField.vue';
export default {
  name: 'WidgetMetaEditor',
  components: {
    WidgetTypeSelect,
    WidgetSizeSelect,
    TemplateTextField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    dataSet: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'color', 'inpFilled']),
    twins() {
      if (get(this.dataSet, 'error')) {
        return [];
      }
      return Object.values(get(this, 'dataSet.data', {})).map(chartTypeDataArray => chartTypeDataArray.map(data => data.twin).flat()).flat().filter(Boolean);
    },
    widgetTitle: {
      get() {
        return get(this.value, 'title');
      },
      set(val) {
        const clone = cloneDeep(this.value);
        clone.title = val;
        this.$emit('input', clone);
      }
    },
    hideHeader: {
      get() {
        return get(this.value, 'hideHeader');
      },
      set(val) {
        const clone = cloneDeep(this.value);
        clone.hideHeader = val;
        this.$emit('input', clone);
      }
    },
    floatHeader: {
      get() {
        return get(this.value, 'floatHeader');
      },
      set(val) {
        const clone = cloneDeep(this.value);
        clone.floatHeader = val;
        this.$emit('input', clone);
      }
    },
    borderless: {
      get() {
        return get(this.value, 'borderless');
      },
      set(val) {
        const clone = cloneDeep(this.value);
        clone.borderless = val;
        this.$emit('input', clone);
      }
    },
    minHeightPx: {
      get() {
        return get(this.value, 'minHeightPx', null);
      },
      set(val) {
        if (val === undefined) {
          val = null;
        }
        if (val !== null) {
          val = Number(val);
          if (isNaN(val)) {
            val = null;
          }
        }
        const clone = cloneDeep(this.value);
        clone.minHeightPx = val;
        this.$emit('input', clone);
      }
    },
    widgetSize: {
      get() {
        return get(this.value, 'size');
      },
      set(val) {
        const clone = cloneDeep(this.value);
        clone.size = val;
        this.$emit('input', clone);
      }
    },
    widgetType: {
      get() {
        return get(this.value, 'type');
      },
      set(val) {
        const clone = cloneDeep(this.value);
        clone.type = val;
        if (val === 'chart') {
          clone.chartOptions = {
            stateIdentifiers: [],
            type: 'line'
          };
        }
        if (val === 'twin-table') {
          clone.twinTableOptions = {
            columns: [{
              property: 'twin.title',
              label: ''
            }]
          };
        }
        this.$emit('input', clone);
      }
    }
  }
};